import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import license from 'scoreboard/components/license'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import emailValidator from 'scoreboard/components/validators/email-validator'
import user from 'scoreboard/components/user'
import template from './welcome-support-form.hbs'

const WelcomeSupportForm = Backbone.View.extend({

	tagName: 'form',

	className: 'welcome-support-form',

	initialize: function () {
		this.markedFields = []
		this.formView = new FormView({
			el: this.el,
			submit: this.submit.bind(this),
			guard: false
		})
	},

	render: function () {
		const trial = license.trial

		this.$el.empty().append(template({
			userLabel: user.model.get('label'),
			email: user.model.get('email'),
			trial
		}))

		formHelper.writeToDom(this.model, this.el)

		if (trial) {
			this.markedFields.push(new MarkedField({
				el: this.$('[name=firstName]'),
				validator: requiredValidator
			}).render())
			this.markedFields.push(new MarkedField({
				el: this.$('[name=lastName]'),
				validator: requiredValidator
			}).render())
			this.markedFields.push(new MarkedField({
				el: this.$('[name=email]'),
				validator: [requiredValidator, emailValidator]
			}).render())
		}
		this.markedFields.push(new MarkedField({
			el: this.$('[name=message]'),
			validator: requiredValidator
		}).render())

		this.formView.start()

		return this
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this.markedFields, 'remove')
	},

	submit: function () {
		const formData = formHelper.readFromDom(this.el)
		$.post('api/email/support', JSON.stringify(formData), response => {
			this.trigger('done')
		}).fail(err => this.formView.start())
	}
})

export default WelcomeSupportForm

WelcomeSupportForm.__filename__ = 'home/welcome-support-form.js'
